import { Button } from "@material-ui/core";
import { formatPrice } from "../../helpers/formatHelper";

export const OrderRecapButton: React.FC<{
    totalPrice: number;
    goToNext: () => void;
    nextLabel: string;
    disableAction?: boolean;
}> = ({ totalPrice, goToNext, nextLabel, disableAction }) => {
    const formattedPrice = formatPrice(totalPrice);
    const label = totalPrice > 0 ? `${nextLabel} ${formattedPrice}` : nextLabel;

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <Button className="accent-button" disabled={disableAction} onClick={goToNext}>
                        {label}
                    </Button>
                </div>
            </div>
        </div>
    );
};
